import type { OfferStatus } from '@recruitee/offers-types';

import { CloseEventProps, CopiedShareUrl, PublishEventProps } from './jobs.analytics.types';

export enum OffersGroupType {
  custom = 'No group',
  department = 'Department',
  status = 'Status',
  title = 'Title',
  location = 'Location',
  tags = 'Tags',
  country = 'Country',
  state = 'State',
  languages = 'Languages',
  recruiter = 'Recruiter',
  hiring_manager = 'Hiring Manager',
  work_model = 'Work model',
}

export enum OffersColumnId {
  title = 'Title',
  candidatesCount = 'Candidates',
  newCandidatesCount = 'New candidates',
  hiredCandidatesCount = 'Hires',
  disqualifiedCandidatesCount = 'Disqualified',
  qualifiedCandidatesCount = 'Qualified',
  department = 'Department',
  location = 'Location',
  stateName = 'State/Region',
  languages = 'Languages',
  publishDate = 'Scheduled publish',
  closeDate = 'Scheduled close',
  publishedAt = 'Publish date',
  closedAt = 'Close date',
  teamMembers = 'teamMembers',
  offerTags = 'Tags',
  createdAt = 'Date created',
  openTime = 'Open time',
  manage = 'Manage',
  followers = 'Followers',
  eeo = 'EEO compliance',
  recruiter = 'Recruiter',
  hiring_manager = 'Hiring manager',
  job_guid = 'Job ID',
  talent_pool_guid = 'TalentPool ID',
  requisitions = 'Requisitions',
  locationName = 'Job location',
  job_location_address = 'Job location address',
  work_model = 'Work model',
  priority = 'Priority',
}

export enum OffersScope {
  active = 'Active',
  archived = 'Archived',
}

export type SocialMediaType = 'linkedin' | 'facebook' | 'x';

export abstract class OfferAnalytics {
  public abstract trackPublish?(props: PublishEventProps): void;
  public abstract trackClose?(props: CloseEventProps): void;
  public abstract trackCreateNew?(): void;
  public abstract trackEdit?(status: 'internal' | 'public' | 'draft' | 'closed' | 'archived'): void;
  public abstract trackDuplicate?(): void;
  public abstract trackPreviewJob?(): void;
  public abstract trackSaveNewUrl?(): void;
  public abstract trackCopyJobLink?(link: CopiedShareUrl): void;
  public abstract trackCopyTrackableURL?(source: string): void;
  public abstract trackShareOnSocialMedia?(type: SocialMediaType): void;
  public abstract trackAssignRequisitionToJob?(
    hasSharedOpenings: boolean,
    jobStatus: OfferStatus,
  ): void;
  public abstract trackOpeningsFilled?(count: number, isBasedOnRequisition: boolean): void;
  public abstract trackArchive?(): void;
  public abstract trackDelete?(): void;
  public abstract trackGroupBy(type: keyof typeof OffersGroupType): void;
  public abstract trackAdjustColumns(
    selectedField: keyof typeof OffersColumnId,
    enabled: boolean,
  ): void;
  public abstract trackViewType(view: string): void;
  public abstract trackChangeScope(scope: 'active' | 'archived'): void;
  public abstract trackChangeFilterTab(scope: keyof typeof OffersScope, tab: number): void;
}
